// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./sass/_AttachShadowPolyfill.scss
// module id = 587
// module chunks = 18 21 88